import { render, staticRenderFns } from "./VxCellAntifraudPoints.vue?vue&type=template&id=a6a9d25a&"
import script from "./VxCellAntifraudPoints.vue?vue&type=script&lang=js&"
export * from "./VxCellAntifraudPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports